import { render, staticRenderFns } from "./CommonCMSPage.vue?vue&type=template&id=4ac4f4af&scoped=true&"
import script from "./CommonCMSPage.vue?vue&type=script&lang=ts&"
export * from "./CommonCMSPage.vue?vue&type=script&lang=ts&"
import style0 from "./CommonCMSPage.vue?vue&type=style&index=0&id=4ac4f4af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac4f4af",
  null
  
)

export default component.exports